module.exports = __webpack_public_path__ + "media/our-new-home.6603f339.mp4";